import i18n from "@/i18n";
import UtilService from "@/services/UtilService";

export interface userRole {
  text: string;
  value: string;
  colour: string;
  allowCreate: boolean;
}

export default class User {
  userId!: number;
  name!: string;
  email!: string;
  role!: string;
  restaurantIds: number[] = [];
  countryCode!: string;
  creationDate!: string;
  language!: string;
  darkTheme!: boolean;

  constructor(jsonObj?: User) {
    if (jsonObj) {
      User.updateUser(this, jsonObj);
    }
  }

  static updateUser(toUpdate: User, user: User) {
    toUpdate.userId = user.userId;
    toUpdate.name = user.name;
    toUpdate.email = user.email;
    toUpdate.role = user.role;
    toUpdate.countryCode = user.countryCode;
    toUpdate.restaurantIds = user.restaurantIds;
    toUpdate.creationDate = user.creationDate;
    toUpdate.language = user.language;
    toUpdate.darkTheme = user.darkTheme;
  }

  static copy(user: User) {
    return new User(JSON.parse(JSON.stringify(user)));
  }

  static haveDifferences(user1: User, user2: User) {
    return !UtilService.equals(user1, user2);
  }

  static roles: userRole[] = [
    {
      text: i18n.tc("user.role.admin"),
      value: "ADMIN",
      colour: "red",
      allowCreate: false
    },
    {
      text: i18n.tc("user.role.manager"),
      value: "MANAGER",
      colour: "orange",
      allowCreate: true
    },
    {
      text: i18n.tc("user.role.staff"),
      value: "STAFF",
      colour: "grey",
      allowCreate: true
    }
  ];
}
